import React from 'react';

import { NavLink } from 'react-router-dom';

function ReportsMenu() {
    return (
        <>


            <ul className="sub-menu">
                <li><NavLink to="/reports/cash-receiveable">Cash Receiveable</NavLink></li>
                <li><NavLink to="/reports/cash-payable">Cash Payable</NavLink></li>
                <li><NavLink to="/reports/summary-sheet">Summary Sheet</NavLink></li>
                <li><NavLink to="/reports/purchases-report">Purchase Report</NavLink></li>
                <li><NavLink to="/reports/sales-report">Sales Report</NavLink></li>
                <li><NavLink to="/reports/trading-accounts">Trading Account</NavLink></li>
                <li><NavLink to="/reports/profit-on-sales">Profit on Sales</NavLink></li>
                <li><NavLink to="/reports/expenses-report">Expenses Report</NavLink></li>
                <li><NavLink to="/reports/investment-summary">Investment Summary</NavLink></li>
                <li><NavLink to="/reports/date-wise-summary">Datewise Summary</NavLink></li>
                <li><NavLink to="/reports/date-wise-product-summary">Datewise Product Summary</NavLink></li>
                <li><NavLink to="/reports/date-wise-product-wise-sale">Datewise Product Wise Sale</NavLink></li>
            </ul>
        </>
    );
}

export default ReportsMenu;